module.exports = __webpack_public_path__ + "static/media/bolso (24).a1d54716.jpg";